/**
 * NDG Contact Form — view.js
 *
 * Store Interactivity API pour le formulaire de contact.
 */

import { store, getContext } from '@wordpress/interactivity';
import { getRecaptchaToken, preloadRecaptcha } from '../../js/utils/recaptcha.js';

const STORE_NS = 'ndg/contact-form';

store( STORE_NS, {

	actions: {

		preloadRecaptcha() {
			preloadRecaptcha( getContext().recaptchaSiteKey );
		},

		setField( event ) {
			const field = event.target.dataset.field;
			if ( field ) {
				getContext()[ field ] = event.target.value;
			}
		},

		toggleField( event ) {
			const field = event.target.dataset.field;
			if ( field ) {
				getContext()[ field ] = event.target.checked;
			}
		},

		*submit( event ) {
			event.preventDefault();

			const context = getContext();

			if ( context.isSubmitting ) return;

			context.isSubmitting = true;
			context.isSuccess    = false;
			context.isError      = false;

			try {
				const token = yield getRecaptchaToken( context.recaptchaSiteKey, context.recaptchaAction );

				const response = yield fetch( context.restUrl, {
					method:  'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-WP-Nonce':   context.nonce,
					},
					body: JSON.stringify( {
						firstname:       context.firstname,
						lastname:        context.lastname,
						email:           context.email,
						phone:           context.phone,
						message:         context.message,
						newsletter:      context.newsletter,
						consent:         context.consent,
						website:         context.website,
						require_message: context.requireMessage,
						lang:            context.lang,
						recaptcha_token: token,
					} ),
				} );

				const data = yield response.json();

				if ( response.ok && data.ok ) {
					context.isSuccess  = true;
					context.firstname  = '';
					context.lastname   = '';
					context.email      = '';
					context.phone      = '';
					context.message    = '';
					context.newsletter = false;
					context.consent    = false;
				} else {
					context.isError = true;
				}
			} catch {
				context.isError = true;
			} finally {
				context.isSubmitting = false;
			}
		},
	},
} );
